import * as React from "react";
import styled from "styled-components";

import history from "../../domain/history/history";
import Button from "./Button";
import {
    BackButtonContainer, ContentBase, ContentContainer, FullScreenContainer, Headline
} from "./FullScreenStyles.sc";

const Credits: React.FunctionComponent = () => (
    <FullScreenContainer>
        <ContentContainer>
            <ContentWrapper>
                <Headline>Credits</Headline>
                <TextContainer>
                    This project was developed as part of the MultiMediaTechnology Master's degree programme at the
                    University of Applied Sciences Salzburg. The students Natasha Troth, Robin Fellinger, Ash
                    Spiegelmayr and Magdalena Maislinger are responsible for the technical implementation. All game
                    elements and the design for the user interface were created by MultiMediaArt student Kerstin
                    Schaumberger. The music and sound elements were created by the MultiMediaArt artist Tobias Türk. For
                    the game design we got support from the MultiMediaTechnology student Nicolas Vana.
                </TextContainer>
                <Headline>Privacy Policy</Headline>
                Last updated: December 28, 2021
                <TextContainer>
                    This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of
                    Your information when You use the Service and tells You about Your privacy rights and how the law
                    protects You. We use Your Personal data to provide and improve the Service. By using the Service,
                    You agree to the collection and use of information in accordance with this Privacy Policy.
                    <Headline>Interpretation and Definitions Interpretation</Headline>
                    <SubHeading>Interpretation</SubHeading>
                    The words of which the initial letter is capitalized have meanings defined under the following
                    conditions. The following definitions shall have the same meaning regardless of whether they appear
                    in singular or in plural.
                    <SubHeading>Definitions</SubHeading>
                    For the purposes of this Privacy Policy:
                    <ul>
                        <li>
                            <b>Company</b> (referred to as either "the Company", "We", "Us" or "Our" in this Agreement)
                            refers to Monstrous Mini Games.
                        </li>
                        <li>
                            <b>Country</b> refers to: Austria
                        </li>
                        <li>
                            <b>Device</b> means any device that can access the Service such as a computer, a cellphone
                            or a digital tablet.
                        </li>
                        <li>
                            <b>Personal Data</b> is any information that relates to an identified or identifiable
                            individual.
                        </li>
                        <li>
                            <b>Service</b> refers to the Website.
                        </li>
                        <li>
                            <b>Service Provider</b> means any natural or legal person who processes the data on behalf
                            of the Company. It refers to third-party companies or individuals employed by the Company to
                            facilitate the Service, to provide the Service on behalf of the Company, to perform services
                            related to the Service or to assist the Company in analyzing how the Service is used.
                        </li>
                        <li>
                            <b>Usage Data</b> refers to data collected automatically, either generated by the use of the
                            Service or from the Service infrastructure itself.
                        </li>
                        <li>
                            <b>Website</b> refers to Monstrous Mini Games, accessible from
                            https://monstrous-minigames.web.app/
                        </li>
                        <li>
                            <b>You</b> means the individual accessing or using the Service, or the company, or other
                            legal entity on behalf of which such individual is accessing or using the Service, as
                            applicable.
                        </li>
                    </ul>
                    <Headline>Collecting and Using Your Personal</Headline>
                    <SubHeading>Data Types of Data Collected</SubHeading>
                    <b>Personal Data</b>
                    <br />
                    While using Our Service, We may ask You to provide Us with certain personally identifiable
                    information that can be used to contact or identify You. Personally identifiable information may
                    include, but is not limited to:
                    <ul>
                        <li>First name</li>
                        <li>Usage Data</li>
                        <li>Images you upload within the scope of use</li>
                    </ul>
                    <b>Usage Data</b>
                    <br />
                    Usage Data is collected automatically when using the Service. Usage Data may include information
                    such as Your Device's Internet Protocol address (e.g. IP address), browser type, browser version,
                    the pages of our Service that You visit, unique device identifiers and other diagnostic data. When
                    You access the Service by or through a mobile device, We may collect certain information
                    automatically, including, but not limited to, the type of mobile device You use, Your mobile device
                    unique ID, the IP address of Your mobile device, Your mobile operating system, the type of mobile
                    Internet browser You use, unique device identifiers, microphone input, sensor data and other
                    diagnostic data. We may also collect information that Your browser sends whenever You visit our
                    Service or when You access the Service by or through a mobile device.
                    <Headline>Use of Your Personal Data</Headline>
                    The Company may use Personal Data for the following purposes:
                    <ul>
                        <li>
                            <b>To provide and maintain our Service</b>, including to monitor the usage of our Service.
                        </li>
                    </ul>
                    We may share Your personal information in the following situations:
                    <ul>
                        <li>
                            <b>With other users:</b> when You share personal information or otherwise interact in the
                            public areas with other users, such information may be viewed by all users and may be
                            publicly distributed outside.
                        </li>
                    </ul>
                    <Headline>Retention of Your Personal Data</Headline>
                    The Company will retain Your Personal Data only for as long as is necessary for the purposes set out
                    in this Privacy Policy. We will retain and use Your Personal Data to the extent necessary to comply
                    with our legal obligations (for example, if we are required to retain your data to comply with
                    applicable laws), resolve disputes, and enforce our legal agreements and policies. Usage Data is
                    generally retained for a shorter period of time, except when this data is used to strengthen the
                    security or to improve the functionality of Our Service, or We are legally obligated to retain this
                    data for longer time periods.
                    <Headline>Transfer of Your Personal Data</Headline>
                    Your information, including Personal Data, is processed at the Company's operating offices and in
                    any other places where the parties involved in the processing are located. It means that this
                    information may be transferred to — and maintained on — computers located outside of Your state,
                    province, country or other governmental jurisdiction where the data protection laws may differ than
                    those from Your jurisdiction. Your consent to this Privacy Policy followed by Your submission of
                    such information represents Your agreement to that transfer. The Company will take all steps
                    reasonably necessary to ensure that Your data is treated securely and in accordance with this
                    Privacy Policy and no transfer of Your Personal Data will take place to an organization or a country
                    unless there are adequate controls in place including the security of Your data and other personal
                    information.
                    <Headline>Disclosure of Your Personal Data</Headline>
                    The Company may disclose Your Personal Data in the good faith belief that such action is necessary
                    to:
                    <ul>
                        <li>Comply with a legal obligation</li>
                        <li>Protect and defend the rights or property of the Company</li>
                        <li>Prevent or investigate possible wrongdoing in connection with the Service</li>
                        <li>Protect the personal safety of Users of the Service or the public</li>
                        <li>Protect against legal liability</li>
                    </ul>
                    <Headline>Security of Your Personal Data</Headline>The security of Your Personal Data is important
                    to Us, but remember that no method of transmission over the Internet, or method of electronic
                    storage is 100% secure. While We strive to use commercially acceptable means to protect Your
                    Personal Data, We cannot guarantee its absolute security.
                    <Headline>Links to Other Websites</Headline>
                    Our Service may contain links to other websites that are not operated by Us. If You click on a third
                    party link, You will be directed to that third party's site. We strongly advise You to review the
                    Privacy Policy of every site You visit. We have no control over and assume no responsibility for the
                    content, privacy policies or practices of any third party sites or services.
                    <Headline>Changes to this Privacy Policy</Headline>
                    We may update Our Privacy Policy from time to time. We will notify You of any changes by posting the
                    new Privacy Policy on this page. We will update the "Last updated" date at the top of this Privacy
                    Policy. You are advised to review this Privacy Policy periodically for any changes. Changes to this
                    Privacy Policy are effective when they are posted on this page.
                    <Headline>Contact Us</Headline>
                    If you have any questions about this Privacy Policy, You can contact us by email:
                    <ul>
                        <li>office.mmt@fh-salzburg.ac.at</li>
                    </ul>
                </TextContainer>
            </ContentWrapper>
        </ContentContainer>
        <BackButtonContainer>
            <Button onClick={history.goBack}>Back</Button>
        </BackButtonContainer>
    </FullScreenContainer>
);

export default Credits;

const TextContainer = styled.div`
    margin: 20px 40px;
    line-height: 24px;
    letter-spacing: 1px;
    text-align: left;
`;

const ContentWrapper = styled(ContentBase)`
    && {
        overflow: scroll;
        align-items: center;
    }
`;

const SubHeading = styled.div`
    font-weight: 700;
    font-size: 18px;
    margin: 10px 0;
`;
